import { useBreakpoint } from "../../hooks/useBreakpoint";
import { useCookieBannerStore } from "../../store/cookieBannerStore";
import Button from "../ui/button/button";
import "./map.scss";

const Map = () => {
  const { hasConsent } = useCookieBannerStore();
  const { showCookieBanner } = useCookieBannerStore();

  const device = useBreakpoint();
  const isMobile = device === "mobile" || device === "tablet";

  return (
    <div className="map">
      {!!hasConsent ? (
        <iframe
          title="Sede Rotoinfissioni"
          className="map__iframe"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5619.487823340931!2d11.86861042922465!3d45.2327477646922!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x477ee89bd3ddbd57%3A0xb5f1de2c46fea5c!2sVia%20Vittorio%20Emanuele%20II%2C%2041%2F1%2C%2035026%20Conselve%20PD%2C%20Italia!5e0!3m2!1sit!2snl!4v1786374930575!5m2!1sit!2snl"
          width="100%"
          height="100%"
          loading="lazy"
        ></iframe>
      ) : (
        <div className="map__no-cookie-container">
          <p className="map__no-cookie-text">
            Per visualizzare la mappa è necessario accettare i cookie di terze
            parti
          </p>
          <Button
            fullWidth={!!isMobile}
            text={"Modifica il Consenso"}
            type={"primary"}
            onClick={showCookieBanner}
          />
        </div>
      )}
    </div>
  );
};

export default Map;
